import React from 'react'
import { Flex, Link } from '@theme-ui/components'
import ContactDetails from '../../../General/ContactDetails'
import CloudinaryImage from '../../../General/CloudinaryImage'
import MultiButtons from '../../../General/MultiButtons/MultiButtonsV2'
import Copyright from '../../../General/Copyright'
import SocialIcons from '../../../General/SocialIcons/SocialIconsV1'
import GonationLogoPowered from '../../../General/GonationLogoPowered'
import combineSocialLinks from '../../../../helpers/combineSocialLinks'

export default function Index({ businessData, configData, variantName, locations, navLinks, locationIndex, options }) {
  const {
    avatar: { imageBaseUrl, imagePrefix },
    slug,
    name,
    street,
    city,
    links,
    state,
    zip
  } = businessData

  const { backgroundColor, containerStyles, linkedin, pinterest, email } = options

  const isMultiLocationSite = locations.length > 1
  const styles = containerStyles ? JSON.parse(containerStyles) : {}

  const variant = variantName ? variantName : 'footerV1'

  const configuredSocialLinks =
    linkedin || pinterest ? combineSocialLinks(links, linkedin?.[locationIndex], pinterest) : links

  return (
    <Flex
      variant={`${variant}.container`}
      sx={styles}
      style={{
        backgroundColor: backgroundColor ? backgroundColor : ''
      }}
      className={'footer'}
    >
      <CloudinaryImage variant={`${variant}.logo`} imageBaseUrl={imageBaseUrl} imagePrefix={imagePrefix} />

      <ContactDetails
        phone={businessData.phone}
        address={{ name, street, city, state, zip }}
        alternativeGoogleMapLink={configData.alternativeGoogleMapLink}
        email={email?.[locationIndex] ?? links?.email ?? ''}
      />
      <MultiButtons isMultiLocationSite={isMultiLocationSite} links={navLinks} city={city} />

      <SocialIcons slug={slug} links={configuredSocialLinks} />
      <Copyright name={name} />
      <GonationLogoPowered />
    </Flex>
  )
}
